/*
export function logout(context) {
    localStorage.removeItem('authState');
    context.commit('setAuthState', {
        username: false,
        apikey: false
    })
}
*/

import {setCookie, shuffleArray} from "@/helperFunctions";

export function searchForProducts(context, query) {
	const that = this;
	return new Promise((resolve, reject) => {
		let url = 'listing/search?prpage=1000';
		if( typeof query === 'object' && Object.keys(query).length !== 0 )
		{
			url += '&';
			Object.keys(query).forEach((property) => {
				if(query[property] !== '')
				{
					url += property + '=' + query[property] + '&';
				}
			});
			url = url.substr(0, url.length - 1);
		}
		
 		that._vm.$guloggratisApi.get(url)
		.then(response => {
			if(typeof response === 'object' && typeof response.hits !== 'undefined')
			{
				const randomised = response.hits;
				shuffleArray(randomised);
				context.commit('setProducts',randomised);
				resolve(response);
			}
			else
			{
				reject('unknown structure');
			}
		})
		.catch(error => {
			reject(error);
		})
	});
}


export function ensureProduct(context,id) {
	const that = this;
	return new Promise((resolve, reject) => {
		if(typeof context.state.products[id] !== 'undefined')
		{
			resolve(context.state.products[id])
		}
		else
		{
			that._vm.$guloggratisApi.get('listing/'+id)
			.then(response => {
				if(typeof response === 'object' && typeof response.id !== 'undefined')
				{
					context.commit('setProducts',[response]);
					resolve(response);
				}
				else
				{
					reject('unknown structure');
				}
			})
			.catch(error => {
				reject(error);
			})
		}
	});
}


export function ensureKraemmerdata(context,id) {
	const that = this;
	return new Promise((resolve, reject) => {
		if(typeof context.state.kraemmerData[id] !== 'undefined')
		{
			resolve(context.state.kraemmerData[id])
		}
		else
		{
			const key = that._vm.$vorbasseSocket.onCommand('return-kraemmer-data-by-id',(data) => {
				if(data.result === 200)
				{
					context.commit('setKraemmerData',data.data);
					resolve(data.data)
				}
				else
				{
					reject(data.reason);
				}
				that._vm.$vorbasseSocket.dropCommandListener('return-kraemmer-data-by-id', key);

			})
			that._vm.$vorbasseSocket.emit('return-kraemmer-data-by-id',id);
		}
	});
}





export function showPrompt(context,prompt) {
	return new Promise((resolve, reject) => {
		prompt.callback = (value) => {
			if(value === true)
			{
				resolve(true);
			}
			else
			{
				reject(false)
			}
			context.commit('resetPopupPrompt');
		};
		context.commit('setPopupPrompt',prompt);
	});
}




export function performTivoliSpin(context,spinToken) {
	const that = this;
	return new Promise((resolve, reject) => {
		that._vm.$vorbasseShopWp.post({
			action: 'performTivoliSpin',
			token: context.state.authToken,
			spin: spinToken
		})
		.then(result => {
			if(result.is_authenticated === true && result.status === 200)
			{
				const index = context.state.spinTokens.indexOf(spinToken);
				if (index !== -1) {
					let newSpins = context.state.spinTokens.slice(0,context.state.spinTokens.length);
					newSpins.splice(index,1);
					
					if(result.result === 'spins' && typeof result.new_spins !== 'undefined')
					{
						newSpins = newSpins.concat(result.new_spins);
					}
					
					context.commit('setSpinTokens',newSpins);
					setCookie('spin-tokens',newSpins.join(','),24*365);
				}
				resolve(result.result);
			}
			else
			{
				reject(result);
			}
		})
		.catch(error => {
			reject(error);
		})
	});
}
